import React, { FC } from 'react';
import { WixLogo } from '../WixLogo/WixLogo';
import s from './MobileToolbar.scss';

export const MobileToolbar: FC<{ dataHook?: string }> = ({ children, dataHook }) => (
  <div data-hook={dataHook} className={s.mobileToolBar}>
    <WixLogo />
    {children}
  </div>
);
